// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #FBFCFE;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-5: #0042A6;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #CCEDFF;
  --color-mima-light: #EEF2F5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #D1D1D1;
  --color-grey-5: #EBEBF5;
  --color-grey-6: #9898AB;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #C0C0C0;
  --color-light-blue: #EBF2FF;
  --color-light-blue-2: #D4E5FF;
  --color-light-blue-3: #E7F3FE;
  --color-dark-yellow: #7E6E1F;
  --color-light-brown: #f4f5f6;
  --color-light-green: #E4FFEC;
  --color-light-yellow: #FFF5D7;
  --color-light-red: #FFE8E8;
  --color-light-grey: #F3F3FF;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.PlansBilling_top__btn__xH0\\+v {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.PlansBilling_switchMenu__Vzt7E {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 30rem;
  border: 1px solid var(--color-primary);
  border-radius: 1rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.PlansBilling_switchMenu__Vzt7E > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.PlansBilling_switchMenu__active__bejcy {
  background-color: var(--color-primary);
  color: var(--color-white);
  transition: all 0.4s;
}
.PlansBilling_switchMenu__rad__l__2Kl\\+i {
  border-radius: 1rem 0 0 1rem;
}
.PlansBilling_switchMenu__rad__r__qcmwp {
  border-radius: 0 1rem 1rem 0;
}

.PlansBilling_table__section__kabEf {
  margin-top: 2rem;
  background-color: var(--color-white);
  padding: 2rem;
  border-radius: 1rem;
}

.PlansBilling_txs__OmHu\\+ {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
}

.PlansBilling_tx__Um8-r {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: var(--color-light-blue);
  width: 100%;
  padding: 1rem 2rem;
  border-radius: 1rem;
  border: 1px solid var(--color-primary);
}
.PlansBilling_tx__flex__wiNEu {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/PlansBilling/PlansBilling.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;ACTD;;AApDA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;AAuDD;;AApDA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAuDD;AArDC;EACC,sBAAA;EACA,kBAAA;AAuDF;AApDC;EACC,sCAAA;EACA,yBAAA;EACA,oBAAA;AAsDF;AAlDE;EACC,4BAAA;AAoDH;AAjDE;EACC,4BAAA;AAmDH;;AA9CA;EACC,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AAiDD;;AA9CA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAiDD;;AA9CA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;AAiDD;AA/CC;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAiDF","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\t--color-white-2: #FBFCFE;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-5: #0042A6;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-09: #CCEDFF;\n\t--color-mima-light: #EEF2F5;\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffaa00;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #f7d1cd;\n\t--color-deep-red: #9f0000;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #d1d1d1;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #D1D1D1;\n\t--color-grey-5: #EBEBF5;\n\t--color-grey-6: #9898AB;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-6: #2a2828;\n\n\t--color-disabled: #C0C0C0;\n\t--color-light-blue: #EBF2FF;\n\t--color-light-blue-2: #D4E5FF;\n\t--color-light-blue-3: #E7F3FE;\n\n\t--color-dark-yellow: #7E6E1F;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #E4FFEC;\n\t--color-light-yellow: #FFF5D7;\n\t--color-light-red: #FFE8E8;\n\t--color-light-grey: #F3F3FF;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #FBFCFE;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #CCEDFF;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #D1D1D1;\n$color-grey-6:#9898AB;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);\n","@import '../variables/breakpoints';\n@import '../variables/variables';\n\n.top__btn {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n.switchMenu {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 30rem;\n\tborder: 1px solid var(--color-primary);\n\tborder-radius: 1rem;\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t& > * {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__active {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\ttransition: all 0.4s;\n\t}\n\n\t&__rad {\n\t\t&__l {\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t}\n\n\t\t&__r {\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t}\n\t}\n}\n\n.table__section {\n\tmargin-top: 2rem;\n\tbackground-color: var(--color-white);\n\tpadding: 2rem;\n\tborder-radius: 1rem;\n}\n\n.txs {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\twidth: 100%;\n}\n\n.tx {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\tbackground-color: var(--color-light-blue);\n\twidth: 100%;\n\tpadding: 1rem 2rem;\n\tborder-radius: 1rem;\n\tborder: 1px solid var(--color-primary);\n\n\t&__flex {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tgap: 1rem;\n\t\tflex-wrap: wrap;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"top__btn": `PlansBilling_top__btn__xH0+v`,
	"switchMenu": `PlansBilling_switchMenu__Vzt7E`,
	"switchMenu__active": `PlansBilling_switchMenu__active__bejcy`,
	"switchMenu__rad__l": `PlansBilling_switchMenu__rad__l__2Kl+i`,
	"switchMenu__rad__r": `PlansBilling_switchMenu__rad__r__qcmwp`,
	"table__section": `PlansBilling_table__section__kabEf`,
	"txs": `PlansBilling_txs__OmHu+`,
	"tx": `PlansBilling_tx__Um8-r`,
	"tx__flex": `PlansBilling_tx__flex__wiNEu`
};
export default ___CSS_LOADER_EXPORT___;
